import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";

export interface MyTaskItem {
  comment: Record<string, unknown>;
  assignment_rel_id: string;
  due_at: string | null;
  completed: boolean;
  assigned_at: string | null;
}

export interface MyTasksResponse {
  items: MyTaskItem[];
  total: number;
  limit: number;
  offset: number;
}

export const tasksApi = {
  listMine: async (params?: { limit?: number; offset?: number }): Promise<MyTasksResponse> => {
    const response = await api.get<MyTasksResponse>(apiRoutes.tasks.mine, { params });
    return response.data;
  },

  setCompletion: async (commentId: number, complete: boolean): Promise<{ ok: boolean; complete: boolean }> => {
    const response = await api.patch<{ ok: boolean; complete: boolean }>(
      apiRoutes.tasks.completion(commentId),
      { complete }
    );
    return response.data;
  },
};
